import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { useDebounce } from "rooks";

export interface DialogProps {
  actionTitle: string;
  actionCB: () => void;
  actionUseLoading?: boolean;
  actionIsLoading?: boolean;
  title: string;
  content: JSX.Element;
  disableClose?: boolean;
  open: boolean;
  handleClose: () => void;
  thirdActionTitle?: string;
  thirdActionCB?: () => void;
}

export default function SimpleDialog(props: DialogProps) {
  const {
    actionCB,
    actionIsLoading,
    actionUseLoading,
    actionTitle,
    disableClose,
    title,
    content,
    open,
    handleClose,
    thirdActionCB,
    thirdActionTitle,
  } = props;
  const debouncedActionCB = useDebounce(actionCB, 500);
  const debouncedHandleClose = useDebounce(handleClose, 500);

  const localHandleCLose = (_event: any, reason: any) => {
    if (reason && reason === "backdropClick") return;
    handleClose();
  };

  return (
    <>
      <Dialog
        onClose={localHandleCLose}
        open={open}
        style={{ zIndex: 99999999999999 }}
        disableEscapeKeyDown={true}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {thirdActionTitle && (
            <Button variant="contained" onClick={thirdActionCB}>
              {" "}
              {thirdActionTitle}{" "}
            </Button>
          )}
          {actionUseLoading ? (
            <LoadingButton
              variant="contained"
              loading={actionIsLoading}
              onClick={actionCB}
            >
              {actionTitle}
            </LoadingButton>
          ) : (
            <Button variant="contained" onClick={actionCB}>
              {actionTitle}
            </Button>
          )}

          <Button
            disabled={disableClose !== undefined && disableClose}
            variant="contained"
            onClick={debouncedHandleClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
